var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        desktop: _vm.$mq != 'sm',
        player: _vm.store.privatePlayerVisible,
        extended:
            _vm.store.privatePlayerItem.type != 'stream' &&
            _vm.store.privatePlayerItem.type != 'playlist',
    },attrs:{"id":"support"}},[_vm._m(0),_c('router-link',{ref:"supportLink",class:{ up: _vm.visible },attrs:{"to":{ name: 'subscribe' }}},[_vm._v("Support Montez Press Radio")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n        Montez Press Radio is ad-free and dependent on donations and the\n        support of its listeners."),_c('br'),_vm._v("\n        Subscribers of Montez Press Radio get unlimited access to our\n        evergrowing archive of shows.\n    ")])
}]

export { render, staticRenderFns }